import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.some";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.find";
import _defineProperty from "/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.filter";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.some";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import router from "./router";
import store from "./store";
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import getPageTitle from '@/utils/get-page-title';
import { getRouterByUser } from "./utils/routerUtil";
import Vue from 'vue';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login']; // no redirect whitelist

// 根据当前路由匹配当前对应的子项目（高亮）
function currPermissionKey(path) {
  var projects = store.state.permission.projects;
  projects.some(function (item) {
    if (item.routes && Array.isArray(item.routes)) {
      return item.routes.some(function (sub) {
        if (sub === path) {
          store.commit('permission/currPermissionKey', item.permissionKey);
          return true;
        }
      });
    }
  });
}
router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var title, removeTimes, i, index, userInfo, hasToken, roles, wilfully, redirect;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // start progress bar
          NProgress.start();

          // set page title
          title = getPageTitle(to.meta.title);
          if (to.matched && to.matched.length > 2) {
            // 可能存在多个Layout2，需循环删除
            removeTimes = to.matched.filter(function (element) {
              var _element$components;
              return (element === null || element === void 0 || (_element$components = element.components) === null || _element$components === void 0 || (_element$components = _element$components["default"]) === null || _element$components === void 0 ? void 0 : _element$components.name) === 'Layout2';
            }).length;
            for (i = 0; i < removeTimes; i++) {
              index = to.matched.findIndex(function (element) {
                var _element$components2;
                return (element === null || element === void 0 || (_element$components2 = element.components) === null || _element$components2 === void 0 || (_element$components2 = _element$components2["default"]) === null || _element$components2 === void 0 ? void 0 : _element$components2.name) === 'Layout2';
              });
              to.matched.splice(index, 1);
            }
          }
          userInfo = store.state.user.userInfo;
          document.title = (userInfo && userInfo.tenantName && "".concat(userInfo.tenantName, " - ") || '') + title;
          // determine whether the user has logged in
          hasToken = Vue.ls.get('ACCESS_TOKEN'); // 判断token，是否有登陆过
          if (!hasToken) {
            _context.next = 23;
            break;
          }
          if (!(to.path === '/login')) {
            _context.next = 12;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: '/booking/instrument'
          });
          NProgress.done();
          _context.next = 21;
          break;
        case 12:
          roles = store.state.user.roles;
          if (!(roles.length === 0)) {
            _context.next = 18;
            break;
          }
          _context.next = 16;
          return store.dispatch('user/getInfo').then(function (res) {
            getRouterByUser().then(function (res) {
              store.commit('permission/setRouters', res);
              router.addRoutes(res);
              var redirect = decodeURIComponent(from.query.redirect || to.path).trim();
              if (to.path === redirect) {
                // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                next(_objectSpread(_objectSpread({}, to), {}, {
                  replace: true
                }));
              } else {
                // 跳转到目的路由
                next({
                  path: redirect
                });
              }
              Vue.ls.set('SET_CUT_ROUTE', redirect, 12 * 60 * 60 * 1000); // 记录当前路由（用于后端记录用户操作）
            });
          })["catch"](function (error) {
            store.dispatch('user/resetToken');
            Message.error(error || '操作失败');
            next("/login");
            NProgress.done();
          });
        case 16:
          _context.next = 21;
          break;
        case 18:
          if (to.path === '/404') {
            wilfully = store.state.permission.addRouters.find(function (item) {
              return item.children && item.children.length > 0;
            });
            if (wilfully) {
              redirect = decodeURIComponent(wilfully.children[0].path).trim();
              Vue.ls.set('SET_CUT_ROUTE', redirect, 12 * 60 * 60 * 1000); // 记录当前路由（用于后端记录用户操作）
              next(redirect);
            }
          }
          currPermissionKey(to.path);
          next();
        case 21:
          _context.next = 24;
          break;
        case 23:
          /* has no token*/
          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            next("/login");
            NProgress.done();
          }
        case 24:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});